import { render } from "./donutChart.vue?vue&type=template&id=3cc9f977"
import script from "./donutChart.vue?vue&type=script&lang=js"
export * from "./donutChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__